import React from "react";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import GetSignaltekResultView from "./getSignaltekResult";

const SignaltekResultViewer = props => {
  const {
    job,
    translate,
    results,
    subtest,
    pager,
    getSubtestResults,
    subtestSignaltekResults,
    //subtestResultsDisplay,
    // subtestResultsRemote,
    // subtestResultsWiremap,
    chartLineStyle,
    chartMeasurement,
    chartMeasurementUnit,
    chartMeasurementType,
    wiremapStandard,
    showMargin,
    setPreferences,
    preferences,
    onChangeResultsViewer,
    getNetScanResult,
    netScanResultDetail,
    fetch,
    getsubtestWiremapResults,
    subtestWiremapResults,
    getsubtestFiberLengthLossResults,
    subtestFiberLengthLossResults,
    getsubtestPoeResults,
    subtestPoeResults,
    getsubtestMaxthroughputResults,
    subtestMaxthroughputResults,
    getsubtestUptimeResults,
    subtestUptimeResults,
    getsubtestUptimeResultsDetails,
    subtestUptimeResultsDetails,
    getsubtestUptimeResultsDetails_BarClick,
    subtestUptimeResultsDetails_BarClick,
    getsubtestSubTestsettingsResults,
    subtestSubTestSettingsResults,
    clearSubTestSettingsResult,
    getStatsResult,
    subtestStatsResults,
    isBarClicked,
    changeBarClick,
    resetResultsState,
    impersonating
  } = props;

  //   if (
  //     (results && results.data.subtests.length) ||
  //     (results.data.testedcabletype === "FiberCable" ||
  //       results.data.testedcabletype === "Fiber") ||
  //     (results.data.lfttest && results.data.lfttest.length)
  //   ) {
  let test = subtest;
  // if (
  //   results.data.testedcabletype === "FiberCable" ||
  //   results.data.testedcabletype === "Fiber"
  // ) {
  //   test = results.data.testedcabletype;
  // }
  if (results && results.data && results.data.status && results.data.subtests) {
    let View = GetSignaltekResultView(test);
    return View ? (
      <View
        job={job}
        results={results}
        subtest={subtest}
        translate={translate}
        pager={pager}
        getSubtestResults={getSubtestResults}
        // subtestResultsRemote={subtestResultsRemote}
        // subtestResultsDisplay={subtestResultsDisplay}
        // subtestResultsWiremap={subtestResultsWiremap}
        chartLineStyle={chartLineStyle}
        chartMeasurement={chartMeasurement}
        chartMeasurementUnit={chartMeasurementUnit}
        chartMeasurementType={chartMeasurementType}
        //wiremapStandard={wiremapStandard}
        subtestSignaltekResults={subtestSignaltekResults}
        showMargin={showMargin}
        setPreferences={setPreferences}
        preferences={preferences}
        onChangeResultsViewer={onChangeResultsViewer}
        getNetScanResult={getNetScanResult}
        netScanResultDetail={netScanResultDetail}
        fetch={fetch}
        getsubtestWiremapResults={getsubtestWiremapResults}
        subtestWiremapResults={subtestWiremapResults}
        getsubtestFiberLengthLossResults={getsubtestFiberLengthLossResults}
        subtestFiberLengthLossResults={subtestFiberLengthLossResults}
        getsubtestPoeResults={getsubtestPoeResults}
        subtestPoeResults={subtestPoeResults}
        getsubtestMaxthroughputResults={getsubtestMaxthroughputResults}
        subtestMaxthroughputResults={subtestMaxthroughputResults}
        getsubtestUptimeResults={getsubtestUptimeResults}
        subtestUptimeResults={subtestUptimeResults}
        getsubtestUptimeResultsDetails={getsubtestUptimeResultsDetails}
        subtestUptimeResultsDetails={subtestUptimeResultsDetails}
        getsubtestUptimeResultsDetails_BarClick={
          getsubtestUptimeResultsDetails_BarClick
        }
        subtestUptimeResultsDetails_BarClick={
          subtestUptimeResultsDetails_BarClick
        }
        getsubtestSubTestsettingsResults={getsubtestSubTestsettingsResults}
        subtestSubTestSettingsResults={subtestSubTestSettingsResults}
        clearSubTestSettingsResult={clearSubTestSettingsResult}
        getStatsResult={getStatsResult}
        subtestStatsResults={subtestStatsResults}
        isBarClicked={isBarClicked}
        changeBarClick={changeBarClick}
        resetResultsState={resetResultsState}
        impersonating={impersonating}
      />
    ) : null;
  } else {
    return <Typography type="button">No data</Typography>;
  }
};

export default withStyles(styles)(SignaltekResultViewer);
